module.exports = __webpack_public_path__ + "static/spectro-cloud-9e17a8929bd2ddd76dbad4d07154834c.png";